import { render } from "./SamlLogin.vue?vue&type=template&id=4916fa54&scoped=true"
import script from "./SamlLogin.vue?vue&type=script&lang=js"
export * from "./SamlLogin.vue?vue&type=script&lang=js"

import "./SamlLogin.vue?vue&type=style&index=0&id=4916fa54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4916fa54"]])

export default __exports__